import {
  Button,
  Alert,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  Snackbar,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { Colors } from "helpers/Consts";
import { ReactComponent as LoginImage } from "assets/svg/LoginImage.svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import { useMutationLogin } from "services/api/mutations/useMutationLogin";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import FormikTextField from "ui/FormikTextField";
import ResetPasswordDialog from "dialogs/ResetPasswordDialog";
import { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import logger from "../../components/Logger";
import { ICardapioAppState } from "../../redux/RootReducer";

type Props = {
  open: boolean;
  handleClose: () => void;
};

type IFormData = {
  email?: string;
  telefone?: string;
  password?: string;
  enterBy?: string;
};

function LoginDialog({ open, handleClose }: Props) {
  const { search } = useLocation()
  const theme = useTheme();
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const [severity, setSeverity] = useState<string>("");
  const [searchParams] = useSearchParams();
  const place_id = searchParams.get("place_id");
  const [openResetPasswordDialog, setOpenResetPasswordDialog] =
    useState<boolean>(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);

  const { mutate: postLogin, mutateAsync,  } = useMutationLogin();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      enterBy: "telefone",
      telefone: "",
    } as IFormData,
    validationSchema: Yup.object().shape({
      telefone: Yup.string()
        .required("Telefone e/ou senha inválidos.")
        .ensure()
        .when("enterBy", {
          is: (enterBy: string) => enterBy !== "telefone",
          then: Yup.string().email("E-mail e/ou senha inválidos."),
        }),
      password: Yup.string()
        .required("")
        .ensure()
        .when("enterBy", {
          is: (enterBy: string) => enterBy !== "telefone",
          then: Yup.string().required("E-mail e/ou senha inválidos."),
          otherwise: Yup.string().required("Telefone e/ou senha inválidos."),
        }),
    }),
    onSubmit: async (values: IFormData) => {
      // console.log(formik.errors);
      // console.log(values);
      if (values.enterBy !== "telefone") {
        values.email = values.telefone;
        delete values.telefone;
      } else {
        delete values.email;
      }
      // console.log('values', values)
      //postLogin(values);
      logger.log('vamos mutateAsync ')
      const r = await mutateAsync(values)
      // window.location.href = "/";

      logger.log('finalizou mutateAsync e retorno foi: ', r)

      formik.setSubmitting(false);
      setTimeout(() => {
        window.location.href = `/${search}`;
        handleClose();
        resetValues();
      }, 1000);
      // resetValues();
    },
  });
  function resetValues() {
    formik.values.email = "";
    formik.values.enterBy = "telefone";
    formik.values.password = "";
    formik.values.telefone = "";
  }
  const handleResetPasswordDialog = () => {
    setOpenResetPasswordDialog(!openResetPasswordDialog);
  };
  const handleMessage = (msg: string) => {
    setMensagem(msg);
  }
  const handleSeverity = (severity: string) => {
    setSeverity(severity)
  }
  const handleSnackBar = () => {
    setOpenSnackBar(!openSnackBar)
  }
  return (
    <>
      <ResetPasswordDialog
        handleClose={handleResetPasswordDialog}
        open={openResetPasswordDialog}
        handleMessage={handleMessage}
        handleSeverity={handleSeverity}
        handleSnackBar={handleSnackBar}
      />
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => {
          handleClose();
          resetValues();
        }}
        maxWidth={"lg"}
      >
        <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleSnackBar}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          onClose={handleSnackBar}
          severity={'success'}
          sx={{ width: "100%" }}
        >
          {mensagem}
        </Alert>
      </Snackbar>
        <DialogContent>
          <Box>
            <Box>
              <IconButton
                color="primary"
                onClick={() => {
                  handleClose();
                  resetValues();
                }}
              >
                <ArrowBackIosIcon fill={Colors.orangePrimary} />
              </IconButton>
            </Box>
            <Box
              display={"flex"}
              sx={{ alignItems: "center", justifyContent: "center" }}
            >
              <Box
                component="img"
                sx={{ height: "100px" }}
                src={require("assets/img/main_logo.png")}
                alt="Avatar"
              />
            </Box>
            <Typography
              p={2}
              color={Colors.baseTextColor}
              style={{ fontWeight: 700 }}
              fontSize="14px"
              textAlign="center"
            >
              Entrar na sua conta
            </Typography>
            <Box
              display="flex"
              sx={{ alignItems: "center", justifyContent: "center" }}
            >
              <LoginImage height="18vh" width="60vw" />
            </Box>
            <Box>
              <form noValidate onSubmit={formik.handleSubmit}>
                <FormControl
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexGrow: 1,
                  }}
                >
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="enterBy"
                    value={formik.values.enterBy}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="email"
                      control={<Radio size="small" />}
                      onChange={formik.handleChange}
                      onClick={() => {
                        formik.values.email = "";
                        formik.values.telefone = "";
                        formik.values.password = "";
                      }}
                      label={
                        <Typography
                          fontSize="12px"
                          color={Colors.baseTextColor}
                        >
                          Entrar com e-mail
                        </Typography>
                      }
                    />
                    <Box flexGrow={1} />
                    <FormControlLabel
                      value="telefone"
                      control={<Radio size="small" />}
                      onChange={formik.handleChange}
                      onClick={() => {
                        formik.values.email = "";
                        formik.values.telefone = "";
                        formik.values.password = "";
                      }}
                      label={
                        <Typography
                          fontSize="12px"
                          color={Colors.baseTextColor}
                        >
                          Entrar com telefone
                        </Typography>
                      }
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>

                {formik.values.enterBy === "telefone" ? (
                  <FormikTextField
                    id="telefone"
                    type="text"
                    required
                    variant="standard"
                    onChange={formik.handleChange}
                    value={formik.values.telefone}
                  />
                ) : (
                  <TextField
                    sx={{
                      marginTop: "10px",
                      paddingX: 1,
                      MozAnimation: "none",
                      WebkitAppearance: "none",
                      appearance: "none",
                    }}
                    fullWidth
                    id="telefone"
                    type={
                      formik.values.enterBy === "telefone" ? "number" : "email"
                    }
                    placeholder={
                      formik.values.enterBy === "telefone"
                        ? "Telefone"
                        : "E-mail"
                    }
                    variant="standard"
                    required
                    onChange={formik.handleChange}
                    value={formik.values.telefone}
                  />
                )}

                {/*               
              <TextField
                sx={{ 
                  marginTop: "10px", 
                  paddingX: 1, 
                  MozAnimation: 'none',
                  WebkitAppearance: "none",
                  appearance: "none",
                 }}
                fullWidth
                id="telefone"
                type={formik.values.enterBy === "telefone" ? "number" : "email"}
                placeholder={
                  formik.values.enterBy === "telefone" ? "Telefone" : "E-mail"
                }
                variant="standard"
                required
                onChange={formik.handleChange}
                value={formik.values.telefone}
              /> */}
                <TextField
                  sx={{ marginTop: "20px", paddingX: 1 }}
                  fullWidth
                  id="password"
                  placeholder="Digite sua senha"
                  variant="standard"
                  type="password"
                  required
                  onChange={formik.handleChange}
                  value={formik.values.password}
                />
                {formik.errors.telefone && formik.touched.telefone && (
                  <Typography
                    p={1}
                    color={Colors.orangePrimary}
                    style={{ fontWeight: 700 }}
                    fontSize="11px"
                    textAlign="center"
                  >
                    {formik.errors.telefone}
                  </Typography>
                )}
                {formik.errors.password &&
                  formik.touched.password &&
                  !formik.errors.telefone && (
                    <Typography
                      p={1}
                      color={Colors.orangePrimary}
                      style={{ fontWeight: 700 }}
                      fontSize="11px"
                      textAlign="center"
                    >
                      {formik.errors.password}
                    </Typography>
                  )}
                <Button
                  type="submit"
                  color="primary"
                  onClick={() => {}}
                  variant="contained"
                  fullWidth
                  sx={{ color: "white", marginTop: "20px" }}
                  // disabled={formik.isSubmitting}
                >
                  Entrar
                </Button>
              </form>
              <Typography
                p={2}
                color={Colors.orangePrimary}
                style={{ fontWeight: 700 }}
                onClick={() => {
                  setOpenResetPasswordDialog(true);
                }}
                fontSize="11px"
                textAlign="center"
              >
                Esqueci minha senha
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default LoginDialog;
